import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AuthCallback from "./components/AuthCallback";
const Login = lazy(() => import("./pages/Login"));
import LandingPage from "./pages/LandingPage";
const VsCompetitorPage = lazy(() => import("./pages/VsCompetitorPage"));
const TermsPage = lazy(() => import("./pages/TermsPage"));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage"));
import ResumePlanTourChip from "./components/ResumePlanTourChip";
import LegFixReturnBanner from "./components/LegFixReturnBanner";
import OperatingModeShell from "./components/operating/OperatingModeShell";
const RegisterPage = lazy(() => import("./pages/RegisterPage"));
const ForgotPasswordPage = lazy(() => import("./pages/ForgotPasswordPage"));
const ResetPasswordPage = lazy(() => import("./pages/ResetPasswordPage"));
const VerifyEmailPage = lazy(() => import("./pages/VerifyEmailPage"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Wizard = lazy(() => import("./pages/Wizard"));
const BusinessPlanPage = lazy(() => import("./pages/BusinessPlanPage"));
const BusinessHubPage = lazy(() => import("./pages/BusinessHubPage"));
const RoadmapPage = lazy(() => import("./pages/RoadmapPage"));
// Feb 2027 · WeeklyReviewPage removed — the review is now embedded
// on the Hub inside "How am I doing?" as a collapsible so the
// standalone screen was retired at the founder's request.
const CohortPnlPage = lazy(() => import("./pages/CohortPnlPage"));
const LogActualsPage = lazy(() => import("./pages/LogActualsPage"));
const ExperimentsPage = lazy(() => import("./pages/ExperimentsPage"));
const ProjectPage = lazy(() => import("./pages/ProjectPage"));
const StrategicPlanHierarchyPage = lazy(() => import("./pages/StrategicPlanHierarchyPage"));
const PreLaunchHierarchyPage = lazy(() => import("./pages/PreLaunchHierarchyPage"));
const AdvisorRedeemPage = lazy(() => import("./pages/AdvisorRedeemPage"));
const CrmPage = lazy(() => import("./pages/CrmPage"));
const BrochurePreviewPage = lazy(() => import("./pages/BrochurePreviewPage"));
const SharedBrochurePage = lazy(() => import("./pages/SharedBrochurePage"));
const CampaignsPage = lazy(() => import("./pages/CampaignsPage"));
const JourneysPage = lazy(() => import("./pages/JourneysPage"));
const FinancingPage = lazy(() => import("./pages/FinancingPage"));
const ScenariosPage = lazy(() => import("./pages/ScenariosPage"));
const ForecastPage = lazy(() => import("./pages/ForecastPage"));
const PerformancePage = lazy(() => import("./pages/PerformancePage"));
const FeasibilityPage = lazy(() => import("./pages/FeasibilityPage"));
const OptimizationPage = lazy(() => import("./pages/OptimizationPage"));
const ReportsPage = lazy(() => import("./pages/ReportsPage"));
const ProcessImprovementPage = lazy(() => import("./pages/ProcessImprovementPage"));
const OperateActivityPage = lazy(() => import("./pages/OperateActivityPage"));
const SamplePlansPage = lazy(() => import("./pages/SamplePlansPage"));
const PublicExamplesPage = lazy(() => import("./pages/PublicExamplesPage"));
const PublicFaqPage = lazy(() => import("./pages/PublicFaqPage"));
const ServiceAgentsDemoPage = lazy(() => import("./pages/ServiceAgentsDemoPage"));
const AdminVendorRequestsPage = lazy(() => import("./pages/AdminVendorRequestsPage"));
const AdCopyPage = lazy(() => import("./pages/AdCopyPage"));
const AdsTrackingPage = lazy(() => import("./pages/AdsTrackingPage"));
const AdCopyAttributionPage = lazy(() => import("./pages/AdCopyAttributionPage"));
const DocumentsPage = lazy(() => import("./pages/DocumentsPage"));
const CrmDashboardPage = lazy(() => import("./pages/CrmDashboardPage"));
const MarketingDashboardPage = lazy(() => import("./pages/MarketingDashboardPage"));
const DocumentLibraryPage = lazy(() => import("./pages/DocumentLibraryPage"));
const PublicPlanPage = lazy(() => import("./pages/PublicPlanPage"));
const TemplatesPage = lazy(() => import("./pages/TemplatesPage"));
const TemplateDetailPage = lazy(() => import("./pages/TemplateDetailPage"));
const BillingPage = lazy(() => import("./pages/BillingPage"));
const ProfilePage = lazy(() => import("./pages/ProfilePage"));
const GrantsPage = lazy(() => import("./pages/GrantsPage"));
const CompliancePage = lazy(() => import("./pages/CompliancePage"));
const SettingsPage = lazy(() => import("./pages/SettingsPage"));
const HelpPage = lazy(() => import("./pages/HelpPage"));
const SupportPage = lazy(() => import("./pages/SupportPage"));
const AdminSupportPage = lazy(() => import("./pages/AdminSupportPage"));
const QboXeroImportGuidePage = lazy(() => import("./pages/QboXeroImportGuidePage"));
const UserGuidePage = lazy(() => import("./pages/UserGuidePage"));
const IntegrationsPage = lazy(() => import("./pages/IntegrationsPage"));
const GlossaryPage = lazy(() => import("./pages/GlossaryPage"));
const AdminTemplatesPage = lazy(() => import("./pages/AdminTemplatesPage"));
const AdminGlossaryPage = lazy(() => import("./pages/AdminGlossaryPage"));
const AdminDemoPlansPage = lazy(() => import("./pages/AdminDemoPlansPage"));
const AdminVideoAnalyticsPage = lazy(() => import("./pages/AdminVideoAnalyticsPage"));
const AdminBusinessesPage = lazy(() => import("./pages/AdminBusinessesPage"));
const AdminReportsPage = lazy(() => import("./pages/AdminReportsPage"));
const AdminPerformanceReportsPage = lazy(() => import("./pages/AdminPerformanceReportsPage"));
const AdminPerformanceReportDetailPage = lazy(() => import("./pages/AdminPerformanceReportDetailPage"));
const LlmSpendForecastPage = lazy(() => import("./pages/LlmSpendForecastPage"));
const AdminUsersPage = lazy(() => import("./pages/AdminUsersPage"));
const AdminMetricsPage = lazy(() => import("./pages/AdminMetricsPage"));
const AdminPaymentRecoveryPage = lazy(() => import("./pages/AdminPaymentRecoveryPage"));
const AdminPaymentsPage = lazy(() => import("./pages/AdminPaymentsPage"));
const AdminAdvisorPlansPage = lazy(() => import("./pages/AdminAdvisorPlansPage"));
const AdminSubscriptionPlansPage = lazy(() => import("./pages/AdminSubscriptionPlansPage"));
const AdminRolesPage = lazy(() => import("./pages/AdminRolesPage"));
const AdminAdvisorsDirectoryPage = lazy(() => import("./pages/AdminAdvisorsDirectoryPage"));
const AdminStructureRequestsPage = lazy(() => import("./pages/AdminStructureRequestsPage"));
const AdminCronPage = lazy(() => import("./pages/AdminCronPage"));
const AdminEmailAnalyticsPage = lazy(() => import("./pages/AdminEmailAnalyticsPage"));
const AdminMonthlyMoveDigestPreviewPage = lazy(() => import("./pages/AdminMonthlyMoveDigestPreviewPage"));
const AdminTelemetryPage = lazy(() => import("./pages/AdminTelemetryPage"));
const AdminCodeHealthPage = lazy(() => import("./pages/AdminCodeHealthPage"));
const AdminTestPlanPage = lazy(() => import("./pages/AdminTestPlanPage"));
const AdminCommissionsPage = lazy(() => import("./pages/AdminCommissionsPage"));
const ReferralDashboardPage = lazy(() => import("./pages/ReferralDashboardPage"));
const AdminAuditPage = lazy(() => import("./pages/AdminAuditPage"));
const AdminSendBudgetsPage = lazy(() => import("./pages/AdminSendBudgetsPage"));
const AdminAttributionUndoWindowsPage = lazy(() => import("./pages/AdminAttributionUndoWindowsPage"));
const BlogAttributionLaunchPage = lazy(() => import("./pages/BlogAttributionLaunchPage"));
const CreditsSuccessPage = lazy(() => import("./pages/CreditsSuccessPage"));
const CreditsCancelPage = lazy(() => import("./pages/CreditsCancelPage"));
// Feb 2027 · CreditsWalletPage was moved into Settings > Wallet tab.
// `/settings/credits` now redirects to `/settings?tab=wallet` (see the
// Route entry below).
const AdvisorDashboardPage = lazy(() => import("./pages/AdvisorDashboardPage"));
const AdvisorInvitePage = lazy(() => import("./pages/AdvisorInvitePage"));
const AdvisorOperatingViewPage = lazy(() => import("./pages/AdvisorOperatingViewPage"));
const CoBrandedLoginPage = lazy(() => import("./pages/CoBrandedLoginPage"));
const InvestorMarketplaceListPage = lazy(() => import("./pages/InvestorMarketplacePage").then((m) => ({ default: m.InvestorMarketplaceListPage })));
const InvestorMarketplaceDetailPage = lazy(() => import("./pages/InvestorMarketplacePage").then((m) => ({ default: m.InvestorMarketplaceDetailPage })));
const MessagesPage = lazy(() => import("./pages/MessagesPage"));
import AssistanceDock from "./components/AssistanceDock";
import GlossaryQuickSearch from "./components/GlossaryQuickSearch";
import { SubscriptionProvider } from "./lib/subscription";
import { Toaster } from "./components/ui/sonner";
import OfflineBanner from "./components/OfflineBanner";
import SuspenseFallback from "./components/SuspenseFallback";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <SuspenseFallback />;
  }
  if (!user) return <Navigate to="/login" replace />;
  // QA Tester security role: a non-admin system tester. They use the full
  // non-admin app (to exercise the QA Test Plan), so we don't lock their
  // navigation — we only skip the mandatory personality-profile gate, which
  // doesn't apply to a tester account.
  if (user.role === "qa_tester") {
    return children;
  }
  // Sales Referral security role: a sales/affiliate rep. Like the QA tester,
  // they use the full non-admin app + their referral dashboard, so we only
  // skip the mandatory personality-profile gate (it doesn't apply to a rep).
  if (user.role === "sales_referral") {
    return children;
  }
  // Personality Profile gate: skip the mandatory redirect if the user has
  // already engaged with the questionnaire — any saved field (updated_at),
  // any concrete answer (age_range), or a deliberate "skip" (skipped_at) all
  // count as "done" so returning users go straight to the Dashboard.
  const pp = user.personality_profile || {};
  const profileDone = Boolean(pp.updated_at || pp.skipped_at || pp.age_range);
  if (location.pathname !== "/profile" && !profileDone) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/profile?next=${next}`} replace />;
  }
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Detect session_id synchronously during render (not useEffect) to avoid race
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
      <Suspense fallback={<SuspenseFallback />}>
      <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/examples" element={<PublicExamplesPage />} />
      <Route path="/faq" element={<PublicFaqPage />} />
      <Route path="/demo/service-agents" element={<ServiceAgentsDemoPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/p/:token" element={<PublicPlanPage />} />
      <Route path="/brochure/share/:shareId" element={<SharedBrochurePage />} />
      <Route path="/vs-liveplan" element={<VsCompetitorPage competitor="liveplan" />} />
      <Route path="/vs-bizplan" element={<VsCompetitorPage competitor="bizplan" />} />
      <Route path="/vs-enloop" element={<VsCompetitorPage competitor="enloop" />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/wizard/:id"
        element={
          <ProtectedRoute>
            <Wizard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id"
        element={
          <ProtectedRoute>
            <BusinessHubPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/plan"
        element={
          <ProtectedRoute>
            <BusinessPlanPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/roadmap"
        element={
          <ProtectedRoute>
            <RoadmapPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/weekly-review"
        element={<Navigate replace to=".." relative="path" />}
      />
      <Route
        path="/business/:id/cohorts"
        element={
          <ProtectedRoute>
            <CohortPnlPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/log-actuals"
        element={
          <ProtectedRoute>
            <LogActualsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/experiments"
        element={
          <ProtectedRoute>
            <ExperimentsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/project/:projectId"
        element={
          <ProtectedRoute>
            <ProjectPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/strategic-plan"
        element={
          <ProtectedRoute>
            <StrategicPlanHierarchyPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/strategic-plan/hierarchy"
        element={
          <ProtectedRoute>
            <StrategicPlanHierarchyPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/plan/hierarchy"
        element={
          <ProtectedRoute>
            <PreLaunchHierarchyPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/invite/advisor/:token"
        element={<AdvisorRedeemPage />}
      />
      <Route
        path="/invite/guest/:token"
        element={<AdvisorRedeemPage />}
      />
      <Route
        path="/business/:id/crm"
        element={
          <ProtectedRoute>
            <CrmPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/brochure"
        element={
          <ProtectedRoute>
            <BrochurePreviewPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/campaigns"
        element={
          <ProtectedRoute>
            <CampaignsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/ad-copy"
        element={
          <ProtectedRoute>
            <AdCopyPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/ad-copy/attribution"
        element={
          <ProtectedRoute>
            <AdCopyAttributionPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/ads-tracking"
        element={
          <ProtectedRoute>
            <AdsTrackingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/journeys"
        element={
          <ProtectedRoute>
            <JourneysPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/financing"
        element={
          <ProtectedRoute>
            <FinancingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/scenarios"
        element={
          <ProtectedRoute>
            <ScenariosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/forecast"
        element={
          <ProtectedRoute>
            <ForecastPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/performance"
        element={
          <ProtectedRoute>
            <PerformancePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/feasibility"
        element={
          <ProtectedRoute>
            <FeasibilityPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/optimization"
        element={
          <ProtectedRoute>
            <OptimizationPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/reports"
        element={
          <ProtectedRoute>
            <ReportsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/processes"
        element={
          <ProtectedRoute>
            <ProcessImprovementPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/activity"
        element={
          <ProtectedRoute>
            <OperateActivityPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sample-plans"
        element={
          <ProtectedRoute>
            <SamplePlansPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm"
        element={
          <ProtectedRoute>
            <CrmDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/marketing"
        element={
          <ProtectedRoute>
            <MarketingDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/documents"
        element={
          <ProtectedRoute>
            <DocumentLibraryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/:id/documents"
        element={
          <ProtectedRoute>
            <DocumentsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/templates"
        element={
          <ProtectedRoute>
            <TemplatesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/templates/:id"
        element={
          <ProtectedRoute>
            <TemplateDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/billing"
        element={
          <ProtectedRoute>
            <BillingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/grants"
        element={
          <ProtectedRoute>
            <GrantsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/compliance"
        element={
          <ProtectedRoute>
            <CompliancePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/help"
        element={
          <ProtectedRoute>
            <HelpPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/support"
        element={
          <ProtectedRoute>
            <SupportPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/support"
        element={
          <ProtectedRoute>
            <AdminSupportPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/help/qbo-xero-import"
        element={
          <ProtectedRoute>
            <QboXeroImportGuidePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user-guide"
        element={
          <ProtectedRoute>
            <UserGuidePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user-guide/:slug"
        element={
          <ProtectedRoute>
            <UserGuidePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/integrations"
        element={
          <ProtectedRoute>
            <IntegrationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/glossary"
        element={
          <ProtectedRoute>
            <GlossaryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/templates"
        element={
          <ProtectedRoute>
            <AdminTemplatesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/glossary"
        element={
          <ProtectedRoute>
            <AdminGlossaryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/demo-plans"
        element={
          <ProtectedRoute>
            <AdminDemoPlansPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/video-analytics"
        element={
          <ProtectedRoute>
            <AdminVideoAnalyticsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/businesses"
        element={
          <ProtectedRoute>
            <AdminBusinessesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/reports"
        element={
          <ProtectedRoute>
            <AdminReportsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/reports/performance"
        element={
          <ProtectedRoute>
            <AdminPerformanceReportsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/reports/performance/:id"
        element={
          <ProtectedRoute>
            <AdminPerformanceReportDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/llm-spend"
        element={
          <ProtectedRoute>
            <LlmSpendForecastPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute>
            <AdminUsersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/emails"
        element={
          <ProtectedRoute>
            <AdminEmailAnalyticsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/payment-recovery"
        element={
          <ProtectedRoute>
            <AdminPaymentRecoveryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/payments"
        element={
          <ProtectedRoute>
            <AdminPaymentsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/advisor-plans"
        element={
          <ProtectedRoute>
            <AdminAdvisorPlansPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/subscription-plans"
        element={
          <ProtectedRoute>
            <AdminSubscriptionPlansPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/admin-roles"
        element={
          <ProtectedRoute>
            <AdminRolesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/advisors"
        element={
          <ProtectedRoute>
            <AdminAdvisorsDirectoryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/structure-requests"
        element={
          <ProtectedRoute>
            <AdminStructureRequestsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/metrics"
        element={
          <ProtectedRoute>
            <AdminMetricsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/cron"
        element={
          <ProtectedRoute>
            <AdminCronPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/monthly-move-preview"
        element={
          <ProtectedRoute>
            <AdminMonthlyMoveDigestPreviewPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/telemetry"
        element={
          <ProtectedRoute>
            <AdminTelemetryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/code-health"
        element={
          <ProtectedRoute>
            <AdminCodeHealthPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/test-plan"
        element={
          <ProtectedRoute>
            <AdminTestPlanPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/audit"
        element={
          <ProtectedRoute>
            <AdminAuditPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/send-budgets"
        element={
          <ProtectedRoute>
            <AdminSendBudgetsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/attribution/undo-windows"
        element={
          <ProtectedRoute>
            <AdminAttributionUndoWindowsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/vendor-requests"
        element={
          <ProtectedRoute>
            <AdminVendorRequestsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/credits/success"
        element={
          <ProtectedRoute>
            <CreditsSuccessPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/credits/cancel"
        element={
          <ProtectedRoute>
            <CreditsCancelPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/credits"
        element={<Navigate to="/settings?tab=wallet" replace />}
      />
      <Route
        path="/admin/commissions"
        element={
          <ProtectedRoute>
            <AdminCommissionsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/referrals"
        element={
          <ProtectedRoute>
            <ReferralDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/advisor"
        element={
          <ProtectedRoute>
            <AdvisorDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route path="/invite/:token" element={<AdvisorInvitePage />} />
      <Route path="/a/:slug" element={<CoBrandedLoginPage />} />
      <Route
        path="/advisor/operating"
        element={
          <ProtectedRoute>
            <AdvisorOperatingViewPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/advisor/operating/:shareId"
        element={
          <ProtectedRoute>
            <AdvisorOperatingViewPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/investor/marketplace"
        element={
          <ProtectedRoute>
            <InvestorMarketplaceListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/investor/marketplace/:id"
        element={
          <ProtectedRoute>
            <InvestorMarketplaceDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/messages"
        element={
          <ProtectedRoute>
            <MessagesPage />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<LandingPage />} />
      <Route path="/blog/attribution-loop" element={<BlogAttributionLaunchPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </Suspense>
      <ResumePlanTourChip />
      <LegFixReturnBanner />
      <OperatingModeShell />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SubscriptionProvider>
            <AppRouter />
            {/* Feb 26 2026 · Screen-space consolidation — the three
                legacy floating launchers (MentorLauncher /
                HelpLauncher / GlossaryLauncher) are replaced by a
                single AssistanceDock that expands into a fan of the
                same three options. The legacy files remain so their
                unit tests + positioning-audit tests stay green. */}
            <AssistanceDock />
            {/* Feb 2027 · Global Cmd+K glossary quick-search. Mounted
                inside the router so it has access to useNavigate, but
                outside the routes so it works on every screen. */}
            <GlossaryQuickSearch />
            {/* Jun 2026 · Offline Grace — slim "Reconnecting…" strip so a
                dropped connection never looks like a broken app. */}
            <OfflineBanner />
            <Toaster position="top-right" />
          </SubscriptionProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
